(function () {
  'use strict';

  function portalToBody(el) {
    if (el && el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  }

  function getActiveRailPreviewSrc() {
    var active = document.querySelector('.active-railbuilder');
    if (!active) return null;
    var base = active.querySelector('.image-bottom');
    if (base && base.src) return base.src;
    var stacks = active.querySelectorAll('.stack img[src]');
    for (var i = stacks.length - 1; i >= 0; i--) {
      if (stacks[i].src) return stacks[i].src;
    }
    return null;
  }

  function initRailLightbox() {
    var trigger = document.querySelector('[data-pdp-rail-lightbox-trigger]');
    var overlay = document.querySelector('[data-pdp-rail-lightbox]');
    var lightboxImg = document.querySelector('[data-pdp-rail-lightbox-img]');
    portalToBody(overlay);
    if (!trigger || !overlay || !lightboxImg) return;

    function openLightbox() {
      var src = getActiveRailPreviewSrc();
      if (!src) return;
      lightboxImg.src = src;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openLightbox);
    overlay.querySelectorAll('[data-pdp-rail-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeLightbox();
    });
  }

  function hideOptionSelectorUI() {
    document.querySelectorAll('.selector-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('[id^="productSelect-option-"]')) {
        wrapper.classList.add('sr-only');
      }
    });
  }

  function getRailVariants() {
    var el = document.querySelector('[data-rail-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions() {
    var values = [];
    document.querySelectorAll('[id^="productSelect-option-"]').forEach(function (select) {
      var match = select.id.match(/productSelect-option-(\d+)/);
      if (!match) return;
      values[parseInt(match[1], 10)] = select.value;
    });
    return values;
  }

  function variantMatchesOptions(variant, options) {
    for (var i = 0; i < options.length; i++) {
      if (options[i] == null || options[i] === '') continue;
      if (variant['option' + (i + 1)] !== options[i]) return false;
    }
    return true;
  }

  function isComboAvailable(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (variant.available && variantMatchesOptions(variant, options)) return true;
    }
    return false;
  }

  function syncRadiosFromSelects() {
    document.querySelectorAll('[data-rail-option-radio]').forEach(function (radio) {
      var index = radio.getAttribute('data-option-index');
      var select = document.querySelector('#productSelect-option-' + index);
      if (select) {
        radio.checked = radio.value === select.value;
      }
    });
  }

  function updateOptionAvailability(variants) {
    var radios = document.querySelectorAll('[data-rail-option-radio]');
    if (!radios.length || !variants.length) return;

    var selected = getSelectedOptions();
    var byIndex = {};

    radios.forEach(function (radio) {
      var index = parseInt(radio.getAttribute('data-option-index'), 10);
      var testOptions = selected.slice();
      testOptions[index] = radio.value;
      radio.disabled = !isComboAvailable(variants, testOptions);
      (byIndex[index] = byIndex[index] || []).push(radio);
    });

    var changedSelects = [];

    Object.keys(byIndex).forEach(function (index) {
      var group = byIndex[index];
      var checked = null;
      var firstEnabled = null;

      for (var i = 0; i < group.length; i++) {
        if (group[i].checked) checked = group[i];
        if (!firstEnabled && !group[i].disabled) firstEnabled = group[i];
      }

      if (checked && !checked.disabled) return;
      if (!firstEnabled) return;

      if (checked) checked.checked = false;
      firstEnabled.checked = true;

      var select = document.querySelector('#productSelect-option-' + index);
      if (select && select.value !== firstEnabled.value) {
        select.value = firstEnabled.value;
        changedSelects.push(select);
      }
    });

    return changedSelects;
  }

  function initRailOptionRadios() {
    var radios = document.querySelectorAll('[data-rail-option-radio]');
    if (!radios.length) return;

    var variants = getRailVariants();
    var updating = false;

    function refreshAvailability() {
      if (updating) return;
      updating = true;
      var notifySelects = [];
      try {
        for (var guard = 0; guard < 5; guard++) {
          syncRadiosFromSelects();
          var changedSelects = updateOptionAvailability(variants) || [];
          if (!changedSelects.length) break;
          notifySelects = changedSelects;
        }
      } finally {
        updating = false;
      }
      if (!notifySelects.length) return;
      updating = true;
      try {
        notifySelects.forEach(function (select) {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } finally {
        updating = false;
      }
      // Recompute disabled states after OptionSelectors settles.
      updating = true;
      try {
        syncRadiosFromSelects();
        updateOptionAvailability(variants);
      } finally {
        updating = false;
      }
    }

    function bind() {
      var optionSelects = document.querySelectorAll('[id^="productSelect-option-"]');
      if (!optionSelects.length) return false;

      hideOptionSelectorUI();
      refreshAvailability();

      radios.forEach(function (radio) {
        if (radio._railBound) return;
        radio._railBound = true;

        radio.addEventListener('change', function () {
          if (!this.checked) return;
          var select = document.querySelector('#productSelect-option-' + this.getAttribute('data-option-index'));
          if (!select || select.value === this.value) {
            refreshAvailability();
            return;
          }
          select.value = this.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      optionSelects.forEach(function (select) {
        if (select._railBound) return;
        select._railBound = true;
        select.addEventListener('change', refreshAvailability);
      });

      return true;
    }

    if (bind()) return;

    var attempts = 0;
    var interval = setInterval(function () {
      if (bind() || ++attempts > 30) clearInterval(interval);
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRailLightbox();
    initRailOptionRadios();
  });
})();
